<template>
  <div class="mt-10 px-20 relative fm:w-[990px] !bg-white">
    <div class="flex justify-between items-center w-full fm:w-[990px]" id="hiddenForPrint" v-if="shopInfo !== null">
      <div>
        <img :src="shopInfo.logo" class="w-[55px] h-[55px]"/>
      </div>
      <Button @click="print()" text="پرینت" />
    </div>
    <div class="border-b-4 border-gray-200 my-6 fm:w-[990px]"></div>
    <div class="fm:w-[990px] flex flex-col" id="print" v-if="order !== null">
      <div class="flex flex-col gap-3 fm:w-[990px]">
        <div class="flex items-center justify-between gap-2">
          <div class="border border-gray-200 bg-gray-100 h-[6.6rem] w-[5rem] flex items-center justify-center">
            <div class="rotate-[270deg] text-center">
              <span>حق‌العمل کار</span>
            </div>
          </div>
          <div class="flex flex-col gap-8 border border-gray-200 p-4 w-[77%]" v-if="shopInfo !== null">
            <div>
              <ul class="flex justify-between">
                <li class="flex items-center gap-2">
                  <span class="!font-medium text-sm">فروشنده:</span>
                  <span class="text-sm">{{shopInfo.site_name}} ({{shopInfo.site_name_ir}})</span>
                </li>
                <li class="flex items-center gap-2">
                  <span class="!font-medium text-sm">شناسه ملی:</span>
                  <span class="text-sm">{{shopInfo.national_id}}</span>
                </li>
                <li class="flex items-center gap-2">
                  <span class="!font-medium text-sm">شماره ثبت:</span>
                  <span class="text-sm">{{shopInfo.registration_number}}</span>
                </li>
                <li class="flex items-center gap-2">
                  <span class="!font-medium text-sm">شماره اقتصادی:</span>
                  <span class="text-sm">{{shopInfo.economic_number}}</span>
                </li>
              </ul>
            </div>
            <div>
              <ul class="flex justify-between">
                <li class="flex items-center gap-2">
                  <span class="!font-medium text-sm">نشانی شرکت:</span>
                  <span class="text-sm">{{shopInfo.site_address}}</span>
                </li>
                <li class="flex items-center gap-2">
                  <span class="!font-medium text-sm">کدپستی:</span>
                  <span class="text-sm">{{shopInfo.postal_code}}</span>
                </li>
                <li class="flex items-center gap-2">
                  <span class="!font-medium text-sm">تلفن :</span>
                  <span class="text-sm">{{shopInfo.phone}}</span>
                </li>
                <li class="flex items-center gap-2">
                  <span class="!font-medium text-sm">فکس:</span>
                  <span class="text-sm">{{shopInfo.fax}}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="flex items-center justify-between border border-gray-200 p-4 w-[15%] h-[6.6rem] text-center">
            <span>شماره فاکتور:</span>
            <span>{{order.id}}</span>
          </div>
        </div>
        <div class="flex items-center justify-between gap-2" v-if="buyer !== null">
          <div class="border border-gray-200 bg-gray-100 h-[6.6rem] w-[5rem] flex items-center justify-center">
            <div class="rotate-[270deg] text-center">
              <span>خریدار</span>
            </div>
          </div>
          <div class="flex flex-col gap-8 border border-gray-200 p-4 w-[77%]">
            <div>
              <ul class="flex justify-between">
                <li class="flex items-center gap-2">
                  <span class="!font-medium text-sm">خریدار:</span>
                  <span class="text-sm">{{buyer.receiver_name + ' ' + buyer.receiver_last_name}}</span>
                </li>
                <li class="flex items-center gap-2">
                  <span class="!font-medium text-sm">	شماره ‌ملی:</span>
                  <span class="text-sm">{{buyer.national_identity_number}}</span>
                </li>
                <li class="flex items-center gap-2">
                  <span class="!font-medium text-sm">موبایل:</span>
                  <span class="text-sm">{{buyer.mobile}}</span>
                </li>
                <li class="flex items-center gap-2">
                  <span class="!font-medium text-sm">نماینده:</span>
                  <span class="text-sm">{{order.user.name + ' ' + order.user.last_name}}</span>
                </li>
              </ul>
            </div>
            <div>
              <ul class="flex justify-between">
                <li class="flex items-center gap-2">
                  <span class="!font-medium text-sm">استان و شهرسنان :</span>
                  <span class="text-sm">{{buyer.province + ' ' + buyer.city}}</span>
                </li>
                <li class="flex items-center gap-2">
                  <span class="!font-medium text-sm">نشانی :</span>
                  <span class="text-sm">{{buyer.address}}</span>
                </li>
                <li class="flex items-center gap-2">
                  <span class="!font-medium text-sm">کدپستی:</span>
                  <span class="text-sm">{{buyer.postal_code}}</span>
                </li>
                <li class="flex items-center gap-2">
                  <span class="!font-medium text-sm">پلاک:</span>
                  <span class="text-sm">{{buyer.plaque}}</span>
                </li>
              </ul>
            </div>
          </div>
          <div class="flex flex-col justify-between border border-gray-200 p-4 w-[15%] h-[6.6rem]">
            <div class="flex justify-between">
              <span>تاریخ:</span>
              <span>{{$store.getters.dateToPersian(order.created_at)}}</span>
            </div>
            <div class="flex justify-between">
              <span>شماره فاکتور:</span>
              <span>{{order.id}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-3 fm:w-[990px]">
        <div class="flex flex-col">
          <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div class="inline-block min-w-full py-2 sm:px-6 lg:px-8">
              <div class="overflow-hidden fm:w-[990px]">
                <table class="min-w-full border text-center text-sm font-light fm:w-[990px]">
                  <thead class="border-b font-medium">
                    <tr class="bg-gray-100">
                      <th scope="col" class="border-r border-gray-300">ردیف</th>
                      <th class="border-r border-gray-300">شرح کالا</th>
                      <th scope="col" class="border-r border-gray-300">آمر</th>
                      <th scope="col" class="border-r border-gray-300">تعداد</th>
                      <th scope="col" class="border-r border-gray-300">مبلغ واحد (ریال)</th>
                      <th scope="col" class="border-r border-gray-300">بسته بندی (ریال)</th>
                      <th scope="col" class="border-r border-gray-300">تخفیف همکاری</th>
                      <th scope="col" class="border-r border-gray-300">تخفیف تک فروشی</th>
                      <th scope="col" class="border-r border-gray-300">مالیات</th>
                      <th scope="col" class="border-r border-gray-300">جمع کل پس از تخفیف و مالیات و بسته بندی (ریال)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="border-b" v-for="(detail,index) in order.order_details" :key="detail.id">
                      <td class="whitespace-nowrap border-r px-6 py-4 font-medium">{{index+1}}</td>
                      <td class="border-r px-6 py-4 w-[20%]">
                        <span>{{detail.product_title}}</span>
                      </td>
                      <td class="whitespace-nowrap border-r px-6 py-4">{{JSON.parse(detail.seller_info).full_name}}</td>
                      <td class="whitespace-nowrap border-r px-6 py-4">{{detail.count}}</td>
                      <td class="whitespace-nowrap border-r px-6 py-4">{{$store.getters.numberFormat($store.getters.getValueAdded(detail.product_price, false, parseInt(detail.value_added)))}}</td>
                      <td class="whitespace-nowrap border-r px-6 py-4">{{$store.getters.numberFormat(detail.product_package_price * detail.count)}}</td>
                      <td class="whitespace-nowrap border-r px-6 py-4">{{ detail.cooperation_discount }}%</td>
                      <td class="whitespace-nowrap border-r px-6 py-4">{{ detail.single_sell_discount }}%</td>
                      <td class="whitespace-nowrap border-r px-6 py-4">{{detail.value_added}}%</td>
                      <td class="whitespace-nowrap border-r px-6 py-4">{{$store.getters.numberFormat(detail.full_amount)}}</td>
                    </tr>
                    <tr class="border-b">
                      <td colspan="4" class="whitespace-nowrap border-r px-6 py-4"></td>
                      <td colspan="4" class="whitespace-nowrap border-r px-6 py-4">هزینه ارسال (ریال):</td>
                      <td class="whitespace-nowrap border-r px-6 py-4">{{$store.getters.numberFormat(order.transport_price)}}</td>
                    </tr>
                    <tr class="border-b">
                      <td colspan="4" class="whitespace-nowrap border-r px-6 py-4"></td>
                      <td colspan="4" class="whitespace-nowrap border-r px-6 py-4">جمع کل پس از تخفیف و مالیات و هزینه ارسال (ریال):</td>
                      <td class="whitespace-nowrap border-r px-6 py-4">{{$store.getters.numberFormat(((order.order_details.reduce((n, {full_amount}) => parseInt(n) + parseInt(full_amount), 0))) + parseInt(order.transport_price))}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-10 fm:w-[990px] border border-gray-200 mb-10 p-4">
        <ul class="flex justify-evenly">
          <li class="flex flex-col gap-8">
            <span>مهر و امضای فروشنده:</span>

          </li>
          <li class="flex flex-col gap-8">
            <span>مهر و امضای خریدار:</span>
          </li>
        </ul>
      </div>
    </div>
    <Loading :loading="loading" />
  </div>
</template>

<script>
export default{name: "Invoice"}
</script>

<script setup>

import Button from "@/components/Button";
import {onMounted, ref} from "vue";
import Loading from "@/components/Loading";
import axios from "@/plugins/axios";
import { useRoute } from "vue-router"
import store from "@/store";
import Toast from "@/plugins/toast";

let loading = ref(false);
const route = useRoute();

let orderId = ref(route.params['order'])
let shopInfo = ref(null)
let buyer = ref(null)
let order = ref(null)

onMounted(async ()=>{
  await getData()
})

async function getData(){
  loading.value = true;
  await axios.get(`${store.state.api}order/invoice/${orderId.value}`).then(resp=>{
    let data = resp.data.data
    shopInfo.value = data.shop_info;
    buyer.value = data.buyer;
    order.value = data.order;
  }).catch(err=>{
    Toast.error();
  })
  loading.value = false;
}

function print(){
  window.print();
}
</script>

<style scoped>
@media print {
  @page { margin-top: 0;margin-bottom: 0; }
  * {
    -webkit-print-color-adjust: exact !important;   /* Chrome, Safari 6 – 15.3, Edge */
    color-adjust: exact !important;                 /* Firefox 48 – 96 */
    print-color-adjust: exact !important;           /* Firefox 97+, Safari 15.4+ */
  }
  #hiddenForPrint * {
    visibility: hidden;
  }

}
</style>